import React from "react";
import { addClass } from '../../../../util/dom';

/**
 * 
 * @returns The BgisHideDetail button.
 */
export const BgisHideDetail  = () => {

    return <button className='bgis-hide-detail' onClick={()=> {addClass('.bgis-map-area','hide-details');}}>Ausblenden</button>

}
